import React, { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { connect, useDispatch } from "react-redux";

import Footer from "../Constant/Footer";
import TopBar from "../Constant/TopBar";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import * as userActions from "../../actions/index";
import ClassItem from "./ClassItem";

import DeleteConfirmRemove from "../Utility/DeleteConfirmRemove";
import Sidebar from "../Constant/sidebar";

const permission_info = JSON.parse(localStorage.getItem("permissions"));
const user_info = JSON.parse(localStorage.getItem("bss_authuser"));
const school_code = user_info?.school_code === null || user_info === null ? "" :user_info.school_code;

const ClassList = (props) => {
    const dispatch = useDispatch();

    const [filterlimit, setfilterlimit] = useState(10);
    const [filterpage, setfilterpage] = useState(1);
    const [filterorder, setfilterorder] = useState("asc");
    const [filtersort, setfiltersort] = useState("class_name");
    const [filtersearch] = useState(null);

    const [ClassList, setClassList] = useState([]);
    const [ClassListcount, setClassListcount] = useState(0);
    const [is_class_activate, setis_class_activate] = useState(true);

    const [confirm_modal, setconfirm_modal] = useState(false);
    // New states for student check modals
    const [student_check_modal, setStudentCheckModal] = useState(false);
    const [has_students, setHasStudents] = useState(false);
    const [current_class_data, setCurrentClassData] = useState(null);

    const [editconfirmremovedata, seteditconfirmremovedata] = useState([]);

    const navigate = useNavigate();

    const showAddModalHandle = (event) => {
        setconfirm_modal(false);
    };

    const RemoveCourseModule = (event, course_data) => {
        seteditconfirmremovedata(course_data);
        setconfirm_modal(true);
    };

    const ConfirmRemove = (form_data) => {
        setconfirm_modal(false);
        props.onDeleteClass(form_data).then((response) => {
            if (response.success === true) {
                GetAllClassesDetails();
                toast.success(response.message, {
                    position: toast.POSITION.TOP_CENTER,
                });
                setconfirm_modal(false);
            } else {
                toast.error(response.message, {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        });
    };

    const GetAllClassesDetails = useCallback(async () => {
        dispatch(userActions.GetAllClassesDetails(filterpage, filterlimit, filtersort, filterorder, is_class_activate, filtersearch)).then((response) => {
            if (response.success === true) {
                const arrayData = response.data.rows;
                setClassList(arrayData);
                setClassListcount(response.data.count);
            }
            else if (response.status === 401) {
                toast.error(response.message, {
                    position: toast.POSITION.TOP_CENTER,
                });
                setTimeout(() => {
                    navigate(`/${school_code}/dashboard`)
                }, 5000);
            }
        });
    }, [dispatch, filterpage, filterlimit, filtersort, filterorder, is_class_activate]);

    useEffect(() => {
        GetAllClassesDetails();
    }, [GetAllClassesDetails, filterpage, filterlimit, filtersort, filterorder, is_class_activate]);

    const GetLoginUserPermissions = useCallback(async () => {
        dispatch(userActions.GetLoginUserPermissions()).then((response) => {
            if (response.success === true) {             
            }
            else if (response.status === 401) {
                toast.error(response.message, {
                    position: toast.POSITION.TOP_CENTER,   
                });  
            }
        });
    }, [dispatch]);

    useEffect(() => {
        GetLoginUserPermissions();
    }, []);

    // Function to check if class has students before deactivation
    const checkClassStudents = async (class_uuid, class_name, new_status ,class_id) => {
        // Only check for students if trying to deactivate
        if (new_status === false) {
            // Store current class data for later use
            setCurrentClassData({
                class_uuid: class_uuid,
                class_name: class_name
            });
            
            // Call API to get students in this class
            dispatch(userActions.GetAllStudents("", "", "", "", "", "", "", "", class_id)).then((response) => {
                if (response.success === true) {
                    if (response.data.rows && response.data.rows.length > 0) {
                        // Class has students
                        setHasStudents(true);
                        setStudentCheckModal(true);
                    } else {
                        // No students, confirm deactivation
                        setHasStudents(false);
                        setStudentCheckModal(true);
                    }
                } else {
                    toast.error(response.message, {
                        position: toast.POSITION.TOP_CENTER,
                    });
                }
            });
        } else {
            // If activating a class, no need to check for students
            const Payload = {
                class_uuid: class_uuid,
                is_class_activate: new_status,
                class_name: class_name
            };
            updateClassStatus(Payload);
        }
    };

    // Function to update class status
    const updateClassStatus = (payload) => {
        props.onUpdateClassStatus(payload).then((response) => {
            if (response.success === true) {
                GetAllClassesDetails();
                setfilterpage(1);
                toast.success(response.message, {
                    position: toast.POSITION.TOP_CENTER,
                });
            } else {
                toast.error(response.message, {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        });
    };

    // Function for confirming class deactivation
    const confirmClassDeactivation = () => {
        if (current_class_data) {
            const Payload = {
                class_uuid: current_class_data.class_uuid,
                is_class_activate: false,
                class_name: current_class_data.class_name
            };
            updateClassStatus(Payload);
        }
        setStudentCheckModal(false);
    };

    // Function for handling the class activation toggle
    const handleChange = async (event, class_uuid, value, class_name ,class_id) => {
        console.log(class_uuid,"class_uuidclass_uuidclass_uuidclass_uuid" )
        // If trying to deactivate, check for students first
        if (value === false) {
            checkClassStudents(class_uuid, class_name, value ,class_id);
        } else {
            // If activating, no need to check for students
            const Payload = {
                class_uuid: class_uuid,
                is_class_activate: value,
                class_name: class_name
            };
            updateClassStatus(Payload);
        }
    };

    return (
        <>
            
            {confirm_modal && (
                <DeleteConfirmRemove
                    title={`Delete Year?`}
                    bodytitle="Are you sure you want to delete this year ?"
                    editconfirmremovedata={editconfirmremovedata}
                    confirm_modal={confirm_modal}
                    confirmButtonText="Delete"
                    ConfirmRemove={(event) => ConfirmRemove(event)}
                    delete_confirm_modal_action={(modal_action) => showAddModalHandle(modal_action)}
                />
            )}

            
            {student_check_modal && (
                <div className="modal fade show" id="kt_modal_add_module" tabIndex="-1" aria-modal="true" role="dialog" style={{ display: "block", paddingRight: "8px" }}>
                    <div className="modal-dialog mw-650px">
                        <div className="modal-content">
                            <div className="modal-header pb-0 border-0 justify-content-end">
                                <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => setStudentCheckModal(false)}>
                                    <span className="svg-icon svg-icon-1">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                                            <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                                        </svg>
                                    </span>
                                </div>
                            </div>
                            <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0 pb-15">
                                <div className="text-center mb-13">
                                    <h1 className="mb-3">
                                        {has_students ? "Students Found" : "Confirm Deactivation"}
                                    </h1>
                                </div>

                                <div className="mb-8">
                                    {has_students ? (
                                        <p className="text-center">
                                            This year has active students. You need to move these students to another year before you can deactivate this year.
                                        </p>
                                    ) : (
                                        <p className="text-center">
                                            Are you sure you want to deactivate this year?
                                        </p>
                                    )}
                                </div>
                                
                                <div className="d-flex flex-center">
                                    {has_students ? (
                                        <button type="button" className="btn btn-primary" onClick={() => setStudentCheckModal(false)}>
                                            OK
                                        </button>
                                    ) : (
                                        <>
                                            <button type="button" className="btn btn-light me-3" onClick={() => setStudentCheckModal(false)}>
                                                Cancel
                                            </button>
                                            <button type="button" className="btn btn-primary" onClick={confirmClassDeactivation}>
                                                Yes
                                            </button>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Modal backdrop */}
            {student_check_modal && (
                <div className="modal-backdrop fade show"></div>
            )}

            <div id="kt_body" className="header-fixed header-tablet-and-mobile-fixed toolbar-enabled toolbar-fixed aside-fixed" >
                <div className="d-flex flex-column flex-root">
                    <div className="page d-flex flex-row flex-column-fluid">
                        <Sidebar />
                        <div className="wrapper d-flex flex-column flex-row-fluid " id="kt_wrapper">
                            <TopBar />
                            <div className="content d-flex flex-column flex-column-fluid" id="kt_content">
                                <div className="post d-flex flex-column-fluid" id="kt_post">
                                    {/* <!--begin::Container--> */}
                                    <div id="kt_content_container" className="container-fluid">
                                        <div className="tab-content" id="myTabContent">
                                            <div className="tab-pane fade" id="Snapshot" role="tabpanel" aria-labelledby="Snapshot-tab"></div>

                                            <div className="tab-pane fade show active" id="Rollcall" role="tabpanel" aria-labelledby="Rollcall-tab">
                                                <div className="row">
                                                    <div className="col-lg-8">
                                                        <div className="card  tabs-outer">
                                                            <div className="card-header position-relative py-0 details-bg">
                                                                <h2 className="card-title m-0">Year Detail</h2>
                                                                <div className="card-toolbar">
                                                                    {permission_info?.add_class !== false && (
                                                                        <Link to={`/${school_code}/class-list/add-class`} className="btn btn-sm btn-primary apply-btn add-btns addschool-button">Add Year</Link>
                                                                    )}
                                                                </div>
                                                            </div>

                                                            <div className="card-body">
                                                                <div className="card-toolbar">
                                                                    <div className="d-flex align-items-center justify-content-between">
                                                                    </div>

                                                                    <div className="row">
                                                                        <div className="col-sm-12">
                                                                            <ClassItem
                                                                                ClassListcount={ClassListcount}
                                                                                data={ClassList}
                                                                                filterlimit={filterlimit}
                                                                                filterpage={filterpage}
                                                                                RemoveCourseModule={(event, data) => RemoveCourseModule(event, data)}
                                                                                propsfilterpage={(event) => setfilterpage(event)}
                                                                                handleChange={(event, class_uuid, value, class_name ,class_id) => handleChange(event, class_uuid, value, class_name,class_id)}
                                                                                propsfilterlimit={(filterlimit) => {
                                                                                    setfilterlimit(filterlimit);
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-4">
                                                        <div className="card ">
                                                            {/* <!--begin::Header--> */}
                                                            <div className="card-header border-bottom border-bottom-1">
                                                                <h3 className="card-title align-items-start flex-column">
                                                                    <span className="card-label fw-bold text-dark">Filters</span>
                                                                </h3>
                                                            </div>

                                                            <div className="card-body p-6">
                                                                <div className="d-flex flex-column">
                                                                    <h5>Sort By</h5>
                                                                    <div className="d-flex">
                                                                        <button className=
                                                                            {"filter-badge me-2 filter-button " +
                                                                                (filtersort === "class_name" ? "btn btn-primary active-filter" : "btn btn-dark")
                                                                            }
                                                                            onClick={(event) => {
                                                                                if (filterorder === 'desc') {
                                                                                    setfilterorder('asc');
                                                                                }
                                                                                else {
                                                                                    setfilterorder('desc');
                                                                                }
                                                                                setfiltersort('class_name');
                                                                                setfilterpage(1);
                                                                            }}
                                                                        >Name</button>
                                                                    </div>
                                                                </div>

                                                                <div className="d-flex flex-column mt-6">
                                                                    <h5>Show</h5>
                                                                    <div className="d-flex align-items-center">
                                                                        <span className=
                                                                            {"filter-badge me-2 filter-button " +
                                                                                (is_class_activate === "" ? "btn btn-primary active-filter" : "btn btn-dark")
                                                                            }
                                                                            onClick={(event) => {
                                                                                setis_class_activate('');
                                                                                setfilterpage(1);
                                                                            }}
                                                                        >All</span>
                                                                        <span className=
                                                                            {"filter-badge me-2 filter-button " +
                                                                                (is_class_activate === true ? "btn btn-primary active-filter" : "btn btn-dark")
                                                                            }
                                                                            onClick={(event) => {
                                                                                setis_class_activate(true);
                                                                                setfilterpage(1);
                                                                            }}
                                                                        >Active</span>
                                                                        <span className=
                                                                            {"filter-badge me-2 filter-button " +
                                                                                (is_class_activate === false ? "btn btn-primary active-filter" : "btn btn-dark")
                                                                            }
                                                                            onClick={(event) => {
                                                                                setis_class_activate(false);
                                                                                setfilterpage(1);
                                                                            }}
                                                                        >Inactive</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                   
                                </div>
                            </div>
                            <Footer></Footer>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
};

const mapStateToProps = (state) => ({});
const mapDispatchToProps = {
    onUpdateClassStatus: userActions.UpdateClassStatus,
    onDeleteClass: userActions.DeleteClass,
};

export default connect(mapStateToProps, mapDispatchToProps)(ClassList);